import { makeStyles } from 'tss-react/mui';
import { inputStyles } from '../../styles/jss/inputs';
const useStyles = makeStyles()((theme, params, classes) => inputStyles(theme, classes, params));
export default useStyles;
